import { Injectable } from '@angular/core';
import {ApiService} from "./api.service";
import {EntityType} from "@app/shared/enums/entity-type.enum";

@Injectable()
export class PrecioVentaService extends ApiService{

  entityType = EntityType.PRECIO_VENTA;
  url = 'api/seteados/precioventa/';

  getNombres(resource) {
    return this.http.get(`${this.url}nombre`, {
      params: this.object2Params(this.serialize(resource))
    });
  }

  create(resource) {
    return this.http.post(`${this.url}`, resource);
  }


}
